const BACKEND_ARAFAT_URLS = {
    PROD: "https://tsleemback.thecode.sa/",
};

const FRONT_ARAFAT_URLS = {
    PROD: "https://tsleem.com.sa/",
};

export const CURRENT_ARAFAT_URL_BACK = BACKEND_ARAFAT_URLS.PROD
export const CURRENT_ARAFAT_URL_FRONT = FRONT_ARAFAT_URLS.PROD



const BACKEND_MOZDALIFA_URLS = {
    PROD: "https://tsleemback.thcode.sa/",
};


const FRONT_MOZDALIFA_URLS = {
    PROD: "https://tsleem.thcode.sa/",
};

export const CURRENT_MOZDALIFA_URL_BACK = BACKEND_MOZDALIFA_URLS.PROD
export const CURRENT_MOZDALIFA_URL_FRONT = FRONT_MOZDALIFA_URLS.PROD

const BACKEND_MENA_URLS = {
    PROD: "https://tsleemback.thecode.sa/",
};

const FRONT_MENA_URLS = {
    PROD: "https://tsleem.thecode.sa/",
};


export const CURRENT_MENA_URL_BACK = BACKEND_MENA_URLS.PROD
export const CURRENT_MENA_URL_FRONT = FRONT_MENA_URLS.PROD
